import { ChangeDetectionStrategy, Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';


@Component({
  selector: 'app-confirm-dialog',
  imports: [TranslateModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmDialogComponent implements OnInit {

  title: string = 'Confirm';
  message: string = 'Are you sure?';

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any

  ) {

    this.title = this.data.title;
    this.message = this.data.message;
  }
  ngOnInit(): void {
    this.removeAriaHiddenFromAllElements();

  }
  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  removeAriaHiddenFromAllElements(): void {
    // Select all elements with the aria-hidden attribute
    const elements = document.querySelectorAll('[aria-hidden]');

    // Remove aria-hidden from each element
    elements.forEach((element: Element) => {
      element.removeAttribute('aria-hidden');
    });
  }
}
